import i18n from 'resources/locales/i18n'

export const PatientsListTypes = {
  NeedsAttention: {
    type: 'needsAttention',
    title: i18n.t('pages.copilotControl.widgets.needsAttention.title')
  },
  PatientsSentiment: {
    type: 'patientsSentiment',
    title: i18n.t('pages.copilotControl.widgets.patientsSentiment.title')
  }
}
export const CopilotEngagementTypes = {
  PatientsSentiment: 'patientsSentiment',
  Scheduling: 'scanningSchedule'
}

export const CopilotEngagementCategories = {
  Negative: 'negative',
  Neutral: 'neutral',
  Positive: 'positive'
}

/**
 * The lower the score, the better the engagement.
 * If the score is below the positive threshold, it is considered positive engagement.
 * If it's between the positive and neutral thresholds, it's neutral engagement.
 * If it's above the neutral threshold, it's negative engagement.
 */
export const ScanningScheduleScoreThresholds = {
  [CopilotEngagementCategories.Positive]: 0.5,
  [CopilotEngagementCategories.Neutral]: 1.5
}
